export const DEFAULT_FULL_DATES = false;
